<template>
    <transition-group name="fade">
        <div class="Modal" style="z-index:99999" id="NewPwdModal" v-on:keyup.esc="close" role="dialog" aria-modal="true" aria-labelledby="dialogtitle">
            <div class="Modal__Window">
                <button class="Modal__Close Button__Link" type="button" v-on:click.prevent="close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" height="23" width="23" role="img">
                        <title>{{$t('forgotPassword.closeWindow')}}</title>
                        <circle cx="26" cy="26" r="26" fill="#595959" />
                        <path fill="none" stroke="#FFFFFF" stroke-width="4" stroke-miterlimit="10" d="M12.6 12.6L39.4 39.4M39.4 12.6L12.6 39.4" stroke-linecap="round"
                              stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="Panels">
                    <transition-group name="fade-slide">
                        <div>
                            <!--START - Load the data-->
                            <div class="Panels__Item" v-if="panel == 'please-wait' || panel == ''" key="please-wait">

                                <h2 id="dialogtitle">{{$t('setNewPassword.title')}}</h2>
                                <div class="u-marginTop5" aria-live="assertive">
                                    <transition-group name="fade">
                                        <div>
                                            <span class="Validation__Error" v-html="ReturnMessage" v-if="!IsValidData"></span>
                                            <span class="Validation__PleaseWait" v-else>{{$t('setNewPassword.PleaseWait')}}</span>
                                        </div>
                                    </transition-group>
                                </div>
                            </div>
                            <!--END - Load the data-->

                            <div class="Panels__Item" v-if="panel == 'new'" key="new">
                                <h2 id="dialogtitle">{{$t('setNewPassword.title')}}</h2>

                                <div class="u-marginTop5">
                                    <p>{{$t('setNewPassword.intro')}}</p>
                                </div>

                                <div class="u-marginTop4">
                                    <label class="Label" for="password">
                                        {{$t('setNewPassword.passwordField')}}
                                    </label>

                                    <div class="TextField u-marginTop0">
                                        <input class="Input" id="new_password" :type="passwordFieldType" :placeholder="$t('setNewPassword.passwordField')" v-model="password" @keyup.enter="trigger" autocomplete="off" @input="delayTouch()" />
                                        <button class="Button__Link u-marginTop0" type="button" :aria-label="$t('loginpage.showPasswordButton')" @click.prevent="showPassword">
                                            <i class="Icon Icon__password-reveal"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="u-marginTop2">
                                    <label class="Label" for="password_confirm">{{$t('setNewPassword.confirmField')}}</label>
                                    <div class="TextField u-marginTop0">
                                        <input class="Input" id="password_confirm" :type="passwordFieldType" :placeholder="$t('setNewPassword.confirmField')" v-model="password_confirm" @keyup.enter="trigger" @input="delayTouch()" />
                                        <button class="Button__Link u-marginTop0" type="button" :aria-label="$t('loginpage.showPasswordButton')" @click.prevent="showPassword">
                                            <i class="Icon Icon__password-reveal"></i>
                                        </button>
                                    </div>
                                    <div aria-live="assertive">
                                        <span class="Validation__Error" v-if="v$.password_confirm.$error && password_confirm != '' && v$.password_confirm.sameAsPassword.$invalid">
                                            {{$t('setNewPassword.donotMatch')}}
                                        </span>
                                    </div>
                                    <!--<span class="Validation__Success" v-else-if="!$v.formSetPassword.password.$invalid && $v.formSetPassword.password_confirm.sameAsPassword">
                passwords match
            </span>-->
                                    <div aria-live="assertive">
                                        <span class="Validation__Error" v-if="v$.password.$error && password != ''">
                                            {{$t('setNewPassword.passwordFormat')}}
                                        </span>
                                    </div>
                                </div>

                                <div class="u-marginTop2 u-xs-marginTop1" aria-live="assertive">
                                    <transition-group name="fade">
                                        <div>
                                            <span class="Validation__Error" v-html="ReturnMessage" v-if="!IsValidData"></span>
                                            <span class="Validation__PleaseWait" v-else-if="isLoading">{{$t('setNewPassword.PleaseWait')}}</span>
                                        </div>
                                    </transition-group>
                                </div>

                                <div class="u-marginTop2" v-if="!isLoading">
                                    <button class="Button Button--fullWidth" type="submit" :disabled="v$.$validationGroups.formSetPassword.$invalid" ref="continueBtn" v-on:click.prevent="submitPassword">
                                        <span class="span-wrapper">{{$t('setNewPassword.continueBtn')}}</span>
                                    </button>
                                </div>
                            </div>

                            <div class="Panels__Item u-textCenter" v-else-if="panel == 'complete'" key="complete">
                                <div aria-live="assertive">
                                    <i class="Icon Icon__complete-thumbsup u-fontSize4"></i>
                                    <h2 id="dialogtitle">{{$t('setNewPassword.title2')}}</h2>

                                    <div class="u-marginTop3">
                                        <p>{{$t('setNewPassword.intro2')}}</p>
                                    </div>

                                    <div class="u-marginTop2">
                                        <a class="Button Button--fullWidth" href="/Account/LogOn">{{$t('setNewPassword.continuetoMMBtn')}}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </transition-group>
                </div>
            </div>
        </div>
    </transition-group>
</template>

<script>
    // Importing Packages
    import { ref, onMounted, nextTick } from 'vue';
    import { useVuelidate } from '@vuelidate/core';
    import { required, sameAs, minLength } from '@vuelidate/validators';
    import { useRoute } from 'vue-router'
    import axios from 'axios';

    // Importing Components
    import FullLoader from './FullLoader.vue';

    export default {
        components: {
            FullLoader
        },
        setup() {
            const password = ref('');
            const password_confirm = ref('');
            const panel = ref('please-wait');
            const IsValidData = ref(true);
            const ReturnMessage = ref('');
            const PasswordResetModel = ref({});
            const passwordFieldType = ref('password');
            const label = ref('');
            const overlay = ref(true);
            const continueBtn = ref(null);
            const route = useRoute();
            const isLoading = ref(false);
            const link = ref('');

            const rules = {
                password: {
                    minLength: minLength(8),
                    required,
                    custom: value => /^(?!.{100})(?=.{8})(?=.*[^A-Za-z])(?=.*[A-Z])(?=.*[a-z]).*$/g.test(value)
                },
                password_confirm: {
                    required,
                    sameAsPassword: sameAs(password)
                },
                $validationGroups: {
                    formSetPassword: ['password', 'password_confirm']
                }
            };

            const v$ = useVuelidate(rules, { password, password_confirm });

            onMounted(() => {
                nextTick(() => {
                    fetchData();
                });
            });

            const close = () => {
                window.location = "/Account/LogOn";
            }

            const trigger = () => {
                continueBtn.value.click();
            }

            const fetchData = () => {
                isLoading.value = true;
                link.value = route.query.link;
                axios.get("/Account/ResetPassword?link=" + route.query.link).then(response => {
                    if (response.data.IsValidData) {
                        panel.value = "new";
                        IsValidData.value = response.data.IsValidData;
                        ReturnMessage.value = response.data.ReturnMessage;
                        PasswordResetModel.value = response.data.PasswordResetModel;
                    } else {
                        IsValidData.value = response.data.IsValidData;
                        ReturnMessage.value = response.data.ReturnMessage;
                        PasswordResetModel.value = response.data.PasswordResetModel;
                    }
                    //show.value = false;
                    isLoading.value = false;
                    nextTick(() => {
                        modalOpen("NewPwdModal");
                    });
                }).catch(error => {
                    //show.value = false;
                    isLoading.value = false;
                });
            }

            const showPassword = () => {
                passwordFieldType.value = (passwordFieldType.value === 'password') ? 'text' : 'password';
            }

            const submitPassword = () => {
                try {
                    IsValidData.value = true;
                    ReturnMessage.value = "";
                    isLoading.value = true;
                    PasswordResetModel.value.NewPassword = encodeURIComponent(password.value);
                    PasswordResetModel.value.ConfirmPassword = encodeURIComponent(password_confirm.value);
                    PasswordResetModel.value.RequireNotificationGuid = true;
                    PasswordResetModel.value.NotificationGuid = link.value;
                    var qs = require('qs');
                    let token = document.getElementsByName('__RequestVerificationToken')[0].value;
                    var thetoken = "__RequestVerificationToken=" + token + '&';
                    var str = qs.stringify(PasswordResetModel.value);
                    axios.post("/Account/ResetPassword/", thetoken + str)
                        .then(function (response) {
                            if (response.data.IsValidData) {
                                panel.value = "complete";
                            } else {
                                IsValidData.value = response.data.IsValidData;
                                ReturnMessage.value = response.data.ReturnMessage;
                                PasswordResetModel.value = response.data.PasswordResetModel;
                            }
                            isLoading.value = false;
                        }).catch(error => {
                            isLoading.value = false;
                        });
                    nextTick(() => {
                        modalOpen("NewPwdModal");
                    });
                } catch (error) {
                    isLoading.value = false;
                }
            }

            const delayTouch = () => {
                v$.value.$reset();
                //v$.password_confirm.$reset();
                setTimeout(() => {
                    v$.value.$touch();
                    //   v$.password_confirm.$touch();
                }, 2000);
            }

            return {
                link,
                password,
                password_confirm,
                passwordFieldType,
                panel,
                IsValidData,
                ReturnMessage,
                PasswordResetModel,
                label,
                overlay,
                continueBtn,
                close,
                route,
                isLoading,
                trigger,
                fetchData,
                showPassword,
                submitPassword,
                delayTouch,
                v$
            };
        }
    };
</script>
